import React from 'react';

type ScrollStateTypes = 'noScroll' | 'scrollingDown' | 'scrollingUp';

// NOTE: This hook should only be used once in the application.
export default function useScrollState(): ScrollStateTypes {
  const [scrollState, setScrollState] = React.useState<ScrollStateTypes>('noScroll');

  const prevScroll = React.useRef<number>(0);

  const handleScroll = React.useCallback(() => {
    const currScroll = window.pageYOffset;

    setScrollState((currentState) => {
      if (currScroll < 5 && currentState !== 'noScroll') {
        return 'noScroll';
      } else if (currScroll >= prevScroll.current + 1 && currentState !== 'scrollingDown') {
        return 'scrollingDown';
      } else if (currScroll <= prevScroll.current - 1 && currentState !== 'scrollingUp') {
        return 'scrollingUp';
      }
      return currentState;
    });

    prevScroll.current = currScroll;
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return scrollState;
}
